import React from 'react';
import T from 'prop-types';

const chartsReportsPath = (store, category, country) => `/store-insights/top-charts/${store}/${category}/${country}`;
const chartsReportsPathApps = (store, category) => `/store-insights/top-charts/${store}/${category}/united-states`;
const countries = ['U.S.', 'India', 'U.K.', 'Germany', 'Israel'];
const country_slug = ['united-states', 'india', 'united-kingdom', 'germany', 'israel'];
const iosApps = ['Photo &amp; Video', 'Entertainment', 'Social Networking', 'Games', 'Music'];
const googleApps = ['Communication', 'Music & Audio', 'Games', 'Social', 'Entertainment'];
const sdks_left = ['Ad Network', 'Analytics', 'Attibution', 'Crash Reporting', 'Developer Platform'];
const sdks_right = ['Development tools', 'Game Development', 'Media Player', 'Mediation', 'User Aquisition'];

const RelatedAppStoreAnalitics = ({
  store,
  type,
}) => {
  const storeName = store === 'itunes_connect' ? 'iOS' : 'Google Play';
  const apps = store === 'itunes_connect' ? iosApps : googleApps;
  const store_slug = store === 'itunes_connect' ? 'itunes-connect' : 'google-play';
  const categoryByStore = store === 'itunes_connect' ? 'top-overall' : 'overall';
  const isSDKs = type === 'SDKs';
  return (
    <div className="releted-apps-store-analytics">
      <div className="container">
        <h2 className="defaults-headline text-center m-b-xxxl">Related App Store <span className="text-blue">Analysis</span>
        </h2>
        <div className="d-flex flex-items-xxs-center flex-items-xxs-column flex-items-sm-row">
          <div className="m-b d-flex">
            <div className="m-l-sm-auto hidden-sm-up" />
            <ol style={{ maxWidth: isSDKs ? 360 : 300 }} start="06">
              {(!isSDKs ? countries : sdks_left).map((country, i) => (
                <li className="m-b-xs d-flex flex-items-xxs-middle" key={country}>
                  <span className="text-quiet m-r-xs text-xxs-right flex-no-shrink" style={{ width: 20 }}>0{i + 1}.</span>
                  <a
                    className="link-hover-underline text-blue"
                    href={chartsReportsPath(store_slug, categoryByStore, country_slug[i])}
                  >
                    Top {storeName} {!isSDKs && type} {!isSDKs && 'in '}
                    {country === ('U.S.' || 'U.K.') && 'the'}
                    <b> {country}</b>  {isSDKs && type}
                    <span className="hicon-angle-right ml-xxxs">
                      <span />
                    </span>
                  </a>
                </li>
              ))}
            </ol>
            <div className="m-r-auto hidden-sm-up" />
          </div>
          <div className="m-l-xl m-r-xl hidden-xs-down" />
          <div className="m-b d-flex">
            <div className="m-l-sm-auto hidden-sm-up" />
            <ol style={{ maxWidth: isSDKs ? 360 : 320 }} start="06">
              {(!isSDKs ? apps : sdks_right).map((app, i) => (
                <li className="m-b-xs d-flex flex-items-xxs-middle" key={app}>
                  <span className="text-quiet m-r-xs text-xxs-right flex-no-shrink" style={{ width: 20 }}> 
                    {i < 4 && '0'}{i + 6}.
                  </span>
                  <a
                    className="link-hover-underline text-blue"
                    href={chartsReportsPathApps(store_slug, categoryByStore)}
                  >
                    Top {storeName}
                    <b> {app}</b> {type}
                    <span className="hicon-angle-right ml-xxxs">
                      <span />
                    </span>
                  </a>
                </li>
              ))}
            </ol>
            <div className="m-r-auto hidden-sm-up" />
          </div>
        </div>
      </div>
    </div>
  );
};


RelatedAppStoreAnalitics.propTypes = {
  store: T.string.isRequired,
  type: T.string.isRequired,
};
export default RelatedAppStoreAnalitics;
